import {
  CommitmentFormFields,
  useCommitmentEditForm,
} from "features/commitments/CommitmentEditForm";
import { CommitmentSetupTabProps } from "features/commitments/setup/CommitmentSetupTabProps";
import React from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { FormCancelButton } from "shared/components/button/FormCancelButton";
import { FormSubmitButton } from "shared/components/button/FormSubmitButton";
import {
  ContentBlock,
  ContentBlockBody,
  ContentBlockGroup,
} from "shared/components/content/ContentBlock";
import Form from "shared/components/form/Form";
import {
  FormFooter,
  FormFooterActions,
} from "shared/components/form/FormFooter";
import { FormUnsavedIndicator } from "shared/components/form/FormUnsavedIndicator";
import { PageTabBody } from "shared/components/layout/PageTabBody";

export const CommitmentSetupTabBasic: React.FC = () => {
  const { t } = useTranslation(["commitment", "common"]);

  const { fundFamilyId, commitmentId, onCancel } =
    useOutletContext<Required<CommitmentSetupTabProps>>();

  const formProps = useCommitmentEditForm({
    fundFamilyId,
    commitmentId,
  });

  return (
    <PageTabBody>
      <ContentBlockGroup>
        <ContentBlock>
          <ContentBlockBody variant="form">
            <Form {...formProps}>
              <CommitmentFormFields fundFamilyId={fundFamilyId} />
              <FormFooter>
                <FormUnsavedIndicator />
                <FormFooterActions>
                  <FormCancelButton onClick={onCancel} />
                  <FormSubmitButton>
                    {t("commitment:edit.title")}
                  </FormSubmitButton>
                </FormFooterActions>
              </FormFooter>
            </Form>
          </ContentBlockBody>
        </ContentBlock>
      </ContentBlockGroup>
    </PageTabBody>
  );
};
